import React, { useState, useEffect, useMemo } from 'react';
import { FaUsers, FaBox, FaCalendarAlt, FaFileInvoice, FaMoneyBillWave, FaChalkboardTeacher } from 'react-icons/fa';
import { studentAPI, teacherAPI, productAPI, batchAPI, invoiceAPI, paymentAPI } from '../services/api';
import StatCardGrid from '../components/StatCardGrid';
import './Dashboard.css';

function Dashboard() {
  const [stats, setStats] = useState({
    students: 0,
    teachers: 0,
    products: 0,
    batches: 0,
    invoices: 0,
    payments: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const [students, teachers, products, batches, invoices, payments] = await Promise.all([
        studentAPI.getAll(),
        teacherAPI.getAll(),
        productAPI.getAll(),
        batchAPI.getAll(),
        invoiceAPI.getAll(),
        paymentAPI.getAll(),
      ]);

      setStats({
        students: students.data.length,
        teachers: teachers.data.length,
        products: products.data.length,
        batches: batches.data.length,
        invoices: invoices.data.length,
        payments: payments.data.length,
      });
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statItems = useMemo(
    () => [
      { id: 'students', label: 'Students', value: stats.students, icon: FaUsers, color: 'blue' },
      { id: 'teachers', label: 'Teachers', value: stats.teachers, icon: FaChalkboardTeacher, color: 'indigo' },
      { id: 'products', label: 'Products', value: stats.products, icon: FaBox, color: 'purple' },
      { id: 'batches', label: 'Batches', value: stats.batches, icon: FaCalendarAlt, color: 'emerald' },
      { id: 'invoices', label: 'Invoices', value: stats.invoices, icon: FaFileInvoice, color: 'amber' },
      { id: 'payments', label: 'Payments', value: stats.payments, icon: FaMoneyBillWave, color: 'rose' }
    ],
    [stats]
  );

  return (
    <div className="dashboard">
      <div className="container">
        <h1 className="page-title">Admin Overview</h1>
        <p className="page-subtitle">Welcome to EPSILON SKATING CLUB Management System</p>

        <StatCardGrid stats={statItems} loading={loading} layoutMode="grid" />

        <div className="dashboard-section mt-20">
          <h2>Quick Start</h2>
          <div className="quick-links">
            <a href="/students" className="quick-link">
              <FaUsers /> Manage Students
            </a>
            <a href="/teachers" className="quick-link">
              <FaChalkboardTeacher /> Manage Teachers
            </a>
            <a href="/batches" className="quick-link">
              <FaCalendarAlt /> Manage Batches
            </a>
            <a href="/enrollments" className="quick-link">
              <FaUsers /> Student Enrollments
            </a>
            <a href="/attendance" className="quick-link">
              <FaCalendarAlt /> Mark Attendance
            </a>
            <a href="/invoices" className="quick-link">
              <FaFileInvoice /> Manage Invoices
            </a>
          </div>
        </div>

        <div className="dashboard-info mt-20">
          <h3>System Information</h3>
          <ul>
            <li>✅ All CRUD operations fully functional</li>
            <li>✅ Real-time data synchronization</li>
            <li>✅ Comprehensive student management</li>
            <li>✅ Batch and enrollment tracking</li>
            <li>✅ Attendance management</li>
            <li>✅ Invoice and payment tracking</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
